import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';
import { addClass } from '../utils';

axios.interceptors.request.use((request) => {
  if (request.method === 'get') {
    request.params = _.assign(request.params, { _: _.now() });
  }
  return request;
});
axios.defaults.headers.common['Accept-Language'] = 'ko-KR';

const trimOrPass = row => (row && typeof row === 'string' ? _.trim(row) : row);

const prepData = data => _.pickBy(_.mapValues(_.omit(data, 'files'), trimOrPass), v => v || v === 0);

const get = (url, data, config) => {
  const params = prepData(data);
  return axios.get(url, _.assign(config, { params }));
};

const del = (url, data, config) => {
  const params = prepData(data);
  return axios.delete(url, _.assign(config, { params }));
};
const post = (url, data, config) => {
  let nData = '';
  if (typeof data === 'string') nData = data;
  else {
    const params = prepData(data);
    nData = qs.stringify(params, { indices: false });
  }
  return axios.post(url, nData, config);
};

const put = (url, data, config) => {
  let nData = '';
  if (typeof data === 'string') nData = data;
  else {
    const params = prepData(data);
    nData = qs.stringify(params);
  }
  return axios.put(url, nData, config);
};

const MAX_UPLOAD_TOTAL = 90 * 1024 * 1024; // 요청 1건 전체 첨부 용량 상한 (nginx client_max_body_size 보다 여유)

const multipart = (url, data, config) => {
  _.assign(config, { headers: { 'content-type': 'multipart/form-data' } });
  const formData = new FormData();
  const params = prepData(data);
  let totalSize = 0;
  _.forEach(params, (item, key) => {
    if (`${item}` === 'FILE_INPUT_MODEL') {
      _.forEach(item.add, (file) => {
        totalSize += file.size;
        formData.append(key, file);
      });
      _.forEach(item.remove, (remove) => {
        formData.append('removeFiles', remove);
      });
      _.forEach(item.exist, (exist) => {
        formData.append('existFiles', exist.sq);
      });
    } else {
      formData.append(key, item);
    }
  });
  if (totalSize > MAX_UPLOAD_TOTAL) {
    alert('첨부 파일의 전체 용량은 90메가를 넘을 수 없습니다. 파일을 나눠서 저장해주세요.');
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject();
  }
  return axios.post(url, formData, config);
};

const validation = (el, option) => {
  const errors = el.querySelectorAll('.error');
  if (errors.length) {
    let fn = alert;
    if (typeof option === 'function') {
      fn = option;
    } else {
      addClass(el, 'requested');
    }
    fn(errors[0].getAttribute('title') || '미입력된 항목이 있습니다.');
    const input = (errors[0].tagName === 'INPUT' || errors[0].tagName === 'TEXTAREA') ? errors[0] : errors[0].querySelector('input, textarea');
    if (input) input.focus();
  }
  return errors.length === 0;
};


export default {
  get,
  post,
  multipart,
  put,
  delete: del,
  validation,
  stringify: qs.stringify,
  prepData,
};



// WEBPACK FOOTER //
// ./src/utils/oax.js